import type { CentrifugeMessage } from '../messageTypes';

export interface VoteMessage {
  data: {
    type: 'VoteStart' | 'VoteEnd' | 'VoteHide';
    message: string;
    created_at?: number;
  };
  offset: number;
}

export const isVoteMessage = (item: CentrifugeMessage): item is VoteMessage => {
  return (
    'data' in item && (item.data.type === 'VoteStart' || item.data.type === 'VoteEnd' || item.data.type === 'VoteHide')
  );
};
